/*eslint-disable*/
export default (name,url) => {
    const reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if(url){
        r = url.split('?')[1].match(reg);
    }
    if(r!=null)return  unescape(r[2]); 
    return null;
}
